<template>
    <div class="classify-view">
        <ul style="list-style-type:none">
            <li  v-if="isEdit">
                <Icon type="ios-key" class="icon-style"  />
                <title-text :inline="true" :onlyText="false">{{curItemObj ? curItemObj.dataName : '-'}}</title-text>
                <div class="margin-left-20 margin-tb-10 slider-com">
                    <Slider
                        v-model="sliderData"
                        @on-change="changeData"
                        :step="10"
                        :min="10"
                        :max="90"
                        show-input
                    ></Slider>
                </div>
            </li>
            <li  v-else>
                <Icon type="ios-key" class="icon-style" />
                <title-text :inline="true" :onlyText="false">{{curItemObj ? curItemObj.dataName : '-'}}</title-text>
                <div class="margin-left-20 margin-tb-10">
                    {{curItemObj ? curItemObj.dataName : '-'}}:<span class="margin-left-20">{{
                        selectData.dataLevel[0]
                            ? selectData.dataLevel[0].name
                            : '--'
                    }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'hierarchical',
    props: ['initDataObj', 'selectData', 'isEdit', 'curItemObj'],
    data() {
        return {
            start: 10,
            end: 90,
            sliderData: 10
        }
    },
    watch: {
        initDataObj: {
            handler() {
                if (this.initDataObj.DATA_LEVEL) {
                    this.start = this.initDataObj.DATA_LEVEL[0]?.name || 10
                    this.end = this.initDataObj.DATA_LEVEL[this.initDataObj.DATA_LEVEL.length - 1]?.name
                }
            },
            immediate: true,
            deep: true
        },
        selectData: {
            handler() {
                if (this.selectData.dataLevel && this.selectData.dataLevel.length > 0) {
                    this.sliderData = Number(this.selectData.dataLevel[0].name)
                }
            },
            deep: true
        }
    },
    mounted() {
        this.sliderData = Number(this.selectData.dataLevel[0]?.name || 10)
    },
    methods: {
        changeData() {
            this.$nextTick(() => {
                this.initDataObj.DATA_LEVEL.forEach((item) => {
                    item.checked = false
                    if (Number(item.name) === Number(this.sliderData)) {
                        item.checked = true
                    }
                })
            })
        }
    }
}
</script>

<style lang="less" scoped>
// li:before {
//     content: '';
//     width: 6px;
//     height: 6px;
//     display: inline-block;
//     border-radius: 50%;
//     background: var(--comp-selected-color);
//     vertical-align: middle;
//     margin-right: 14px;
// }
.margin-left-20 {
    margin-left: 0px 0px 20px 0px;
}
.icon-style{
    margin-right: 5px;
    font-size: 19px;
}
</style>
